"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentGatewayFragment = exports.paymentFragment = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

exports.paymentFragment = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment Payment on Payment {\n    id\n    gateway\n    token\n    creditCard {\n      brand\n      firstDigits\n      lastDigits\n      expMonth\n      expYear\n    }\n    total {\n      amount\n      currency\n    }\n  }\n"])));
exports.paymentGatewayFragment = graphql_tag_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  fragment PaymentGateway on PaymentGateway {\n    id\n    name\n    config {\n      field\n      value\n    }\n    currencies\n  }\n"])));